module.exports = __webpack_public_path__ + "img/kh1_05.dd812219.png";